// Thin wrappers over the chat API (/api/v1/auth/chat/*). axios has the base URL
// and bearer token from main.js.
import axios from "axios";

const base = "/api/v1/auth/chat";

export default {
  conversations(params) {
    return axios.get(`${base}/conversations`, { params }).then((r) => r.data);
  },
  createConversation(payload) {
    return axios.post(`${base}/conversations`, payload).then((r) => r.data);
  },
  conversation(id) {
    return axios.get(`${base}/conversations/${id}`).then((r) => r.data);
  },
  messages(id, beforeId) {
    return axios.get(`${base}/conversations/${id}/messages`, { params: { before_id: beforeId || undefined } }).then((r) => r.data);
  },
  reply(id, payload) {
    return axios.post(`${base}/conversations/${id}/messages`, payload).then((r) => r.data);
  },
  markRead(id, messageId) {
    return axios.post(`${base}/conversations/${id}/read`, { message_id: messageId || undefined }).then((r) => r.data);
  },
  addParticipants(id, payload) {
    return axios.post(`${base}/conversations/${id}/participants`, payload).then((r) => r.data);
  },
  archive(id, archived) {
    return axios.post(`${base}/conversations/${id}/${archived ? "archive" : "unarchive"}`).then((r) => r.data);
  },
  deleteMessage(id) {
    return axios.delete(`${base}/messages/${id}`).then((r) => r.data);
  },
  unreadCount() {
    return axios.get(`${base}/unread-count`).then((r) => r.data.count);
  },
  searchUsers(q) {
    return axios.get(`${base}/users`, { params: { q } }).then((r) => r.data.data);
  },
  entityTypes(supported) {
    return axios.get(`${base}/entity-types`, { params: { supported: supported.join(",") } }).then((r) => r.data.data);
  },
  searchEntities(q, type) {
    return axios.get(`${base}/entities/search`, { params: { q, type: type || undefined } }).then((r) => r.data.data);
  },
  entity(type, id) {
    return axios.get(`${base}/entities/${type}/${id}`).then((r) => r.data);
  },
};

/** First validation / error message from an API error, for toasts. */
export function errorMessage(error, fallback = "Something went wrong. Please try again.") {
  const data = error?.response?.data;
  if (!data) return fallback;
  if (data.errors) {
    const first = Object.values(data.errors)[0];
    if (Array.isArray(first) && first.length) return first[0];
  }
  return data.message || fallback;
}
